"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var logger_1 = require("./logger");
var Container = function () {
  function Container(_a) {
    var _this = this;
    var _b = _a.providers,
      providers = _b === void 0 ? [] : _b,
      _c = _a.modules,
      modules = _c === void 0 ? null : _c,
      _d = _a.namespace,
      namespace = _d === void 0 ? 'root' : _d;
    this.instanceMap = new Map();
    this._namespace = namespace;
    this.modules = new Map();
    this.depsMap = new Map();
    this.providers = new Map();
    this.registerProviders(providers);
    if (modules) {
      modules.forEach(function (m) {
        m.setParent(_this);
        _this.modules.set(m.namespace, m);
      });
    }
  }
  Container.prototype.getInstance = function (name) {
    var _a;
    var _name = typeof name === "string" ? name : name.name;
    var instance = this.instanceMap.get(_name);
    if (!instance) {
      var def = this.providers.get(_name);
      if (!def) {
        instance = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getInstance(_name);
      } else {
        if (def.useClass) {
          var Construct = def.useClass;
          instance = new Construct();
          this.instanceMap.set(_name, instance);
        } else if (def.useValue) {
          instance = def.useValue;
          this.instanceMap.set(_name, instance);
        } else if (def.useFactory) {
          instance = def.useFactory();
        } else {
          return;
        }
      }
    }
    return instance;
  };
  Container.prototype.registerProviders = function (providers) {
    var _this = this;
    providers.forEach(function (provider) {
      var _provider = provider;
      if (!(provider.useValue || provider.useFactory || provider.useClass)) {
        if (!provider.__is_base_provider__) {
          throw new Error('提供的provider不是一个合法的Provider。');
        }
        _provider = {
          provide: provider.name,
          useClass: provider
        };
      }
      var exist = _this.providers.get(_provider.provide);
      if (exist) {
        logger_1.log('注册Provider失败，因为该令牌的Provider已经存在。');
      } else {
        _this.providers.set(_provider.provide, _provider);
      }
    });
  };
  Container.prototype.getProviders = function () {
    return this.providers;
  };
  Container.prototype.getInstanceMap = function () {
    return this.instanceMap;
  };
  Container.prototype.setParent = function (ctx) {
    if (!(ctx instanceof Container)) {
      throw new Error('模块关联出错，请检查模块的创建方式');
    }
    this.parent = ctx;
  };
  Container.prototype.getParent = function () {
    return this.parent;
  };
  Object.defineProperty(Container.prototype, "namespace", {
    get: function get() {
      return this._namespace;
    },
    enumerable: false,
    configurable: true
  });
  Container.prototype.getModule = function (namespace) {
    return this.modules.get(namespace);
  };
  Container.prototype.registerModule = function (container, namespace) {
    var exist = this.providers.get(namespace);
    if (exist) {
      logger_1.log('注册Module失败，因为该namespace已经存在。');
    } else {
      this.modules.set(namespace, container);
    }
  };
  return Container;
}();
exports.Container = Container;